import type {
  GetOnboardingContentsData,
  GetRedirectUrlData,
  GetTargetVisibilityData,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type OnboardingContents,
  OnboardingContentsSchema,
  type OnboardingVisibility,
  OnboardingVisibilitySchema,
  type OnlineOnboardingRedirect,
  OnlineOnboardingRedirectSchema,
} from './schemas'

const ENTITY = 'Onboarding'

export const adaptOnboardingContents = (raw: GetOnboardingContentsData): OnboardingContents =>
  parseApiResponse(OnboardingContentsSchema, raw, ENTITY)

export const adaptOnboardingVisibility = (raw: GetTargetVisibilityData): OnboardingVisibility =>
  parseApiResponse(OnboardingVisibilitySchema, raw, ENTITY)

export const adaptOnlineOnboardingRedirect = (raw: GetRedirectUrlData): OnlineOnboardingRedirect =>
  parseApiResponse(OnlineOnboardingRedirectSchema, raw, ENTITY)
